module.exports = __webpack_public_path__ + "static/img/ua.a8b13525.svg";